import React from "react";
import Axios from 'axios';
import {Form,Divider,Input, Button} from 'semantic-ui-react';

class Members extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            members:[],
            selectedMember:{}
        }
        this.loadMembers = this.loadMembers.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.updateEmail = this.updateEmail.bind(this);
        this.loadMembers();
    }

    loadMembers(){
        let self = this;
        Axios.get('http://165.227.166.190/members').then((res)=>{
            if(res.data){
                self.setState({
                    members:res.data,
                    selectedMember:{
                        id:null
                    }
                });
                /*
                this.onSelectionChange({
                    target:{
                        value:res.data[0].id
                    }
                });
                */
            }
        });
    }

    onSelectionChange(e){
        if(e.target.value !== "empty"){
            this.state.members.forEach((member)=>{
                if(member.id === parseInt(e.target.value,10)){
                    this.setState({
                        selectedMember: member
                    });
                    this.props.onChange(member);
                }
            });
        }
        else{
            this.setState({
                selectedMember: {
                    id:null,
                    email:""
                }
            });
        }
        
    }

    updateEmail(e){
        const newValue = e.target.value;
        this.setState((prevState)=>{
            let selectedMember = prevState.selectedMember;
            selectedMember.email = newValue;
            Axios.put('http://165.227.166.190/members',selectedMember).then((res)=>{});
            return{
                selectedMember:selectedMember
            };
        });
        
    }

    render(){
        return(
            <div>
                <h2>Wie ben jij?</h2>
                <Form>
                    <Form.Field>
                        <select id="selectMember" value={this.state.selectedMember.id} onChange={this.onSelectionChange}>
                            <option key="0" selected value="empty">Maak een selectie</option>
                            {
                                this.state.members.map((member)=>{
                                    return (
                                        <option key={member.id} value={member.id}>{member.name}</option>
                                    )
                                })
                            }
                        </select>
                        <p><strong>Controleer je email adres aub:</strong></p>
                        <Input value={this.state.selectedMember.email} onChange={this.updateEmail}/>
                    </Form.Field>
                </Form>
                <Divider />
                <Button  styles={{marginTop:"20px"}} onClick={this.props.salesDetailsClicked}>Toon verkoopsoverzicht</Button>
                <Divider />
            </div>
        )
    }

}

export default Members;


// WEBPACK FOOTER //
// ./src/components/members/members.js